module.exports = __webpack_public_path__ + "img/HT01034-01.78098050.jpg";